const ROLES = {
    SUPER_ADMIN: "Super Admin",
    ADMIN: "Admin",
    SALES: "Sales",
    FINANCE: "Finance"
}

export default ROLES;